<div matRipple class="card" [style.margin-right.rem]="1">
  <div [ngClass]="selected===clickType ? 'insight-card-selected' : 'insight-card'">
    <div class="text-container">
      <div class="insight-type">{{clickType | clickTypeFormatter}}</div>
      <div class="insight-value">{{value}}</div>
    </div>
  </div>
</div>
